import { render } from "./ModalBodySectionComponent.vue?vue&type=template&id=b05762e4&scoped=true"
import script from "./ModalBodySectionComponent.vue?vue&type=script&lang=js"
export * from "./ModalBodySectionComponent.vue?vue&type=script&lang=js"

import "./ModalBodySectionComponent.vue?vue&type=style&index=0&id=b05762e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05762e4"]])

export default __exports__